import { ProgramStatus } from "src/enums";
import { Conductor, Program, Promotions } from "src/models";
import { ProgramsConductor, ProgramsConductorInitialState, ReduxAction } from "../models";
import { ProgramConductorTypes, ProgramViewTypes } from "../types";

export const ProgramsConductorState = (state: ProgramsConductor = ProgramsConductorInitialState, action?: ReduxAction): ProgramsConductor => {
    if (!action) return state;

    switch (action.type) {
        case ProgramConductorTypes.SHOW_PROGRAM_CONDUCTOR_LOADING:
        case ProgramConductorTypes.REQUEST_LOAD_PROGRAM_CONDUCTOR:
            const clear = action.payload && action.payload.clearBeforeFetch;
            return { ...state, loading: true, list: clear ? [] : state.list, featured: clear ? [] : state.featured };
        case ProgramConductorTypes.HIDE_PROGRAM_CONDUCTOR_LOADING:
            return { ...state, loading: false, firstLoad: false };
        case ProgramConductorTypes.SET_PROGRAM_CONDUCTOR_DATA:

            const data: { list: Conductor[], promotions: Promotions, clear: boolean, count: number, totalRecords: number } = action.payload;

            let list = [...state.list];

            if (data.clear) {
                data.list.forEach((x) => {
                    x.items.forEach((y) => {
                        y.promotion?.items.forEach((z) => {
                            z.hidden = list.some((a) => a.items.some((b) => b.promotion?.items.some((c) => c.id === z.id && c.hidden)));
                        });
                    });
                });
                list = [...data.list];
            }
            else {
                data.list.forEach((x) => {
                    const sameDate = list.find((y) => y.date === x.date);

                    if (!sameDate) {
                        list = [...list, x];
                        return;
                    }

                    sameDate.items = [...sameDate.items, ...x.items];
                });
            }

            // not using flatMap because of safari short range support
            const featured: Program[] = [];
            list.forEach((a) => {
                const f = a.items.filter((b) => b.program && b.program.isFeatured).map((b) => b.program);
                f.forEach((b) => b && featured.push(b));
            });

            const offset = (data.clear ? 0 : state.offset) + (data.list.length > 0 ? data.count : 0);

            const promotions: Promotions = data.clear ? { ...data.promotions } : {
                ...state.promotions,
                items: [...state.promotions?.items || []],
                ratio: state.promotions?.ratio || 0,
                config: [...state.promotions?.config || []]
            };

            promotions.items.forEach((x) => x.hidden = (state.promotions?.items || []).some((y) => y.id === x.id && y.hidden));

            return {
                ...state,
                list,
                promotions,
                offset,
                featured,
                count: data.count,
                totalRecords: data.totalRecords,
                loading: false,
                firstLoad: false,
            };

        case ProgramViewTypes.SET_PROGRAM_PLAYER_DATA:
            const programId = action.payload.programId;

            if (!programId) return state;

            const s = { ...state };

            for (let day of s.list) {
                let find = false;

                for (let item of day.items) {
                    if (item.program && item.program.id === programId) {
                        if (item.program.status === ProgramStatus.ComingSoon) item.program.status = ProgramStatus.Started;
                        find = true;
                    }
                }

                if (find) break;
            }

            return { ...s };

        case ProgramConductorTypes.HIDE_PROMOTION:
            const { date, itemIndex, promotionIndex } = action.payload || {};

            const st = { ...state };

            if (!date) {
                const item = st?.promotions?.items[promotionIndex];
                if (item) item.hidden = true;
            }
            else {
                for (let day of st.list) {
                    if (day.date === date) {
                        const item = day.items[itemIndex]?.promotion?.items[promotionIndex];
                        if (item) item.hidden = true;
                        break;
                    }
                }
            }

            return { ...st };

    }

    return state;
};
